import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MobileBottomNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const hiddenPaths = ['/login', '/register', '/auth/', '/verify-email'];
    if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

    const tabs = [
        {
            id: 'home',
            label: 'Home',
            path: '/',
            matchPaths: ['/', '/about', '/products'],
            icon: (active) => (
                <svg className={`w-5 h-5 ${active ? 'text-blue-500' : 'text-gray-400'}`} viewBox="0 0 24 24" fill="currentColor">
                    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                </svg>
            ),
        },
        {
            id: 'news',
            label: 'News',
            path: '/dashboard/news',
            matchPaths: ['/news', '/blog', '/dashboard/news'],
            icon: (active) => (
                <svg className={`w-5 h-5 ${active ? 'text-blue-500' : 'text-gray-400'}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
            ),
        },
        {
            id: 'alerts',
            label: 'Dashboard',
            path: '/dashboard',
            matchPaths: ['/alerts', '/addresses', '/watchlist', '/dashboard', '/dashboard/watchlist', '/dashboard/alerts', '/dashboard/integrations'],
            icon: (active) => (
                <svg className={`w-5 h-5 ${active ? 'text-blue-500' : 'text-gray-400'}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
            ),
        },
        {
            id: 'settings',
            label: 'Settings',
            path: '/dashboard/settings',
            matchPaths: ['/settings', '/dashboard/settings'],
            icon: (active) => (
                <svg className={`w-5 h-5 ${active ? 'text-blue-500' : 'text-gray-400'}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
        },
    ];

    const handleTabClick = (tab) => {
        if (tab.id === 'settings' && !isAuthenticated) {
            navigate(`/login?next=${encodeURIComponent(tab.path)}`);
            return;
        }
        navigate(tab.path);
    };

    const isActive = (tab) => {
        return tab.matchPaths.some(p => {
            if (p === '/') return location.pathname === '/';
            return location.pathname.startsWith(p);
        });
    };

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 pb-safe">
            <div className="flex items-center justify-around h-14">
                {tabs.map(tab => {
                    const active = isActive(tab);
                    return (
                        <button
                            key={tab.id}
                            onClick={() => handleTabClick(tab)}
                            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                                active
                                    ? 'text-blue-500'
                                    : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
                            }`}
                        >
                            {tab.icon(active)}
                            <span className={`text-[10px] mt-0.5 font-medium ${active ? 'text-blue-500' : 'text-gray-400'}`}>
                                {tab.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
